document.addEventListener('turbolinks:load', function () {
    if ($('.organizations.show').length === 0) {
        return false
    }

    var myModal = document.querySelectorAll('.clientUpdateDetailModal')
    myModal.forEach(function (modal) {
        modal.addEventListener('shown.bs.modal', function () {
            var clientUpdateId = $(this).attr('data-client-update-id')
            getComments(clientUpdateId)
        })
    })

    function getComments(clientUpdateId) {
        $.ajax({
            url: `/client_updates/${clientUpdateId}/comments`,
            method: 'get'
        }).done(function (res) {
            if (res) {
                var commentSection = $(`#commentSection-${clientUpdateId}`)
                $(commentSection).empty()
                $(commentSection).append(res)
            } else {
                alert('Something went wrong')
            }
        }).fail(function (res) {
            alert('Something went wrong')
        })
    }
});